<!-- 商品的详细信息，标题、价格等， 组件的外面是控制视觉上隐藏效果 -->
<template>
    <div class="detail-about-sku" v-show="skuList && skuList.length">
        <div class="detail-about-sku-count">
            <p class="detail-about-sku-count-text">
                {{ (skuList && skuList.length) || 0 }} 款可选
            </p>
        </div>
        <div class="detail-about-sku-list">
            <div class="list-box" v-for="skuItem in skuList" :key="skuItem.id">
                <div
                    class="detail-about-sku-list-item"
                    :class="{
                        'detail-about-sku-list-item-select': skuItem.isSelect,
                    }"
                    @click="handleSkuItem(skuItem)"
                >
                    <img
                        :src="skuItem.imgUrl"
                        alt=""
                        class="detail-about-sku-img"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive } from 'vue';
import { getSkuList, SkuListItem, UserRole } from '../service';
import cloneDeep from 'lodash-es/cloneDeep';
import { appendParams, parseQuery } from '@/utils/url';
import { pushLogBridge } from '@/utils/weblog-bridge';
interface skuItem extends SkuListItem {
    isSelect: boolean;
}
export default defineComponent({
    props: {
        // 课程Id
        courseId: {
            type: String,
            default: '',
        },
        isShow: {
            type: Boolean,
            default: true,
        },
        dataUserRole: {
            type: Object as PropType<UserRole>,
            default: () => {
                return {};
            },
        },
    },
    setup(props) {
        /**
         * 课程sku有个核心逻辑, 初始进入时的课程id的sku要放在列表 第一个位置
         */
        const skuList = reactive<skuItem[]>([]);
        // 将初始的课程(从业务or课程列表跳转的情况) or Url中存在的课程id的sku(通过切换sku跳转过来的, 而不是从业务方or课程列表跳转的情况)放在第一个位置
        const unShiftSku = () => {
            const params = parseQuery(location.href);
            // 有baseCid优先前置, 没有就取url中的默认courseId
            const unshiftSkuId = params.baseCid || props.courseId;
            const unshiftSkuIndex = skuList.findIndex((ele) => {
                return String(ele.cid) === unshiftSkuId;
            });
            if (unshiftSkuIndex > -1) {
                skuList.unshift(skuList.splice(unshiftSkuIndex, 1)[0]);
            }
        };
        /**
         * 初始化获取sku列表
         */
        const initSkuList = () => {
            getSkuList(props.courseId).then((res) => {
                const resSkuList = res.data || [];
                resSkuList.forEach((ele) => {
                    const item = { ...cloneDeep(ele), isSelect: false };
                    skuList.push(item);
                });
                const selectSku = skuList.find(
                    (ele) => String(ele.cid) === props.courseId,
                );

                if (selectSku) {
                    selectSku.isSelect = true;
                }
                // 按规则将初始的课程(从业务跳转 or sku选择跳转)置位第一个
                unShiftSku();
                // 埋点,如果length>0切符合条件展示时候上报
                if (skuList.length && props.isShow) {
                    pushLogBridge(
                        'sendImmediately',
                        'SHOW',
                        'COURSE_DETAIL_SKU_CARD',
                        {
                            course_num: (skuList && skuList.length) || 0,
                            course_id: props.courseId,
                        },
                    );
                }
            });
        };
        /**
         * sku点击
         * @param item skuItem
         */
        const handleSkuItem = (item: skuItem) => {
            if (item.isSelect) {
                return;
            }
            const params = parseQuery(location.href);
            let search = location.search;
            if (!params.baseCid) {
                // 切换sku的时候，需要设置courseId
                const url = appendParams(location.href, {
                    baseCid: props.courseId,
                });
                search = new URL(url).search;
            }
            pushLogBridge(
                'sendImmediately',
                'CLICK',
                'COURSE_DETAIL_SKU_CARD',
                {
                    course_id: item.cid,
                },
            );
            location.replace(
                `${location.origin}/kt/detail/${item.cid}${search}`,
            );
        };
        initSkuList();

        return { skuList, handleSkuItem };
    },
});
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
}
.detail-about-sku {
    display: flex;
    background-color: #fff;
    position: relative;
    padding-left: 46px;
    height: 106px;
    width: 100vw;
    box-sizing: border-box;
    .detail-about-sku-count {
        position: absolute;
        left: 0;
        top: 0;
        width: 46px;
        padding: 12px 0 12px 10px;
        box-sizing: border-box;
        .detail-about-sku-count-text {
            border-radius: 4px;
            box-sizing: border-box;
            text-align: center;
            width: 28px;
            height: 84px;
            padding: 8px;
            background-color: #f8f8f8;
            font-size: 12px;
            line-height: 17px;
            font-weight: 400;
            font-family: PingFang SC;
            color: #666;
        }
    }
    .detail-about-sku-list {
        padding: 12px 0;
        display: flex;
        overflow-x: auto;
        .list-box {
            width: 90px;
            flex-shrink: 0;
        }
        .detail-about-sku-list-item {
            border-radius: 4px;
            width: 82px;
            overflow: hidden;
            height: 82px;
            // margin-right: 8px;
            border: 0.5px solid #eaeaea;
            flex-shrink: 0;
            box-sizing: border-box;
        }
        .detail-about-sku-list-item:nth-last-child(1) {
            margin-right: 0;
        }
        .detail-about-sku-list-item-select {
            border: 1px solid #fe3666;
        }
        .detail-about-sku-img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
